import React, { useState } from 'react';
import lili from "../../images/lili.png"
import Button from '../../share/button/Button';
import Modal from '../../share/modal/Modal';
import ModalContent from '../../share/modal/ModalContent';
import MintProgress from '../mintprogress/MintProgress';
import MarketStats from '../marketstats/MarketStats';
import { useDispatch } from 'react-redux';
import { resetModalState } from '../../store/modalSlice';
import Header from '../header/Header';
import Footer from '../footer/Footer';

const Section = () => {
    const [isOpen, setIsOpen] = useState(false);
    const dispatch = useDispatch();
    const openModal = () => {
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
        dispatch(resetModalState())
    };
    return (
        // Full-height flex column: the hero grows to absorb any leftover viewport
        // space so the footer always lands at the bottom of the screen. Without
        // this the page ends wherever the content happens to end, leaving a bare
        // strip of body background below the footer on tall/short-content screens.
        <div className="w-full min-h-screen flex flex-col">
        <Header className="shrink-0" />
        <div className="w-full bg-[#FEEEDE] flex-1 flex justify-center items-center overflow-hidden py-10 sm:py-14 md:py-16">
            <div className="relative containers flex items-center flex-col gap-6 sm:gap-8 md:gap-10">
                <img
                    style={{maxWidth:"100%"}}
                    src={lili}
                    className="relative z-50 w-[220px] sm:w-[280px] md:w-[340px] lg:w-[380px] h-auto animate-fade-in-up"
                    alt="Lili png"
                />
                <Button onClick={openModal} size="hero" className="animate-fade-in-up [animation-delay:120ms]">
                    Get my Character
                </Button>
                {/* Sits below the CTA on purpose: the button stays the focal point,
                    and the count reads as a reason to act on it rather than
                    competing with it. Renders nothing if the chain read fails. */}
                <MintProgress />
                {/* Mint price and secondary floor sit together: they are the
                    same decision for a buyer, and splitting them across the
                    page would make neither legible. */}
                <MarketStats />
                <Modal isOpen={isOpen} onClose={closeModal}>
                    <ModalContent/>
                </Modal>
            </div>
        </div>
        <Footer className="shrink-0" />
        </div>
    );
};

export default Section;
